<style lang="scss">
@import './index.scss';
</style>
<template>
    <div class="page-access">
        <div class="page-access-header">
            <h1>{{$t('pageaccess.tab1')}}</h1>
            <div class="page-access-searchbox">
                <associative-search
                  :value="key"
                  :keyname="['pagename', 'page']"
                  :optionlist="tableData"
                  @associative-search="search"
                >
                </associative-search>
                <i class="iconfont icon-download pageaccess-icon" @click="downTable"></i>
              <Poptip :title="$t('portrait.indexInfo')" placement="left-start" trigger="hover">
                <i class="iconfont icon-help pageaccess-icon page-access-explain-icon"></i>
                <div slot="content">
                    <ul>
                      <li><span>{{$t('pageaccess.index.a')}}：</span><p>{{$t('pageaccess.explain.a')}}</p></li>
                      <li><span>{{$t('pageaccess.index.b')}}：</span><p>{{$t('pageaccess.explain.b')}}</p></li>
                      <li><span>{{$t('pageaccess.index.c')}}：</span><p>{{$t('pageaccess.explain.c')}}</p></li>
                      <li><span>{{$t('pageaccess.index.d')}}：</span><p>{{$t('pageaccess.explain.d')}}</p></li>
                      <li><span>{{$t('pageaccess.index.e')}}：</span><p>{{$t('pageaccess.explain.e')}}</p></li>
                      <li><span>{{$t('pageaccess.index.f')}}：</span><p>{{$t('pageaccess.explain.f')}}</p></li>
                      <li><span>{{$t('pageaccess.index.h')}}：</span><p>{{$t('pageaccess.explain.h')}}</p></li>
                      <li><span>{{$t('pageaccess.index.g')}}：</span><p>{{$t('pageaccess.explain.g')}}</p></li>
                    </ul>
                </div>
              </Poptip>
            </div>
        </div>
        <div class="page-access-tablebox">
            <Table ref="table" :columns="tableColumns" :data="tabDatas" :no-data-text="noData" @on-sort-change="sortData" class="page-table">
            </Table>
        </div>
        <div class="page-access-footer">
            <div class="pageOpts">
                <i-select v-model="pageSize" style="width:80px;" @on-change="changePage(1)">
                    <i-option v-for="item in pageSizeOpts" :value="item" :key="item">{{item}}{{ $t('accountAuthorization.pagesize') }}</i-option>
                </i-select>
            </div>
            <div class="page">
                <Page :total="pages" :current="curPage" :page-size="pageSize" :page-size-opts="pageSizeOpts" @on-change="changePage"></Page>
            </div>
        </div>
        <!--产看走向详情-->
        <Modal class-name="page-access-trend" width='708' v-model="trend" :title="$t('pageaccess.link')" >
            <Input icon="ios-search" v-model="pagelink" :placeholder="$t('filter.search')" class="page-access-linksearch" @on-change="filterpagelink" />
            <ul class="page-access-link">
                <li v-if="linkNoData" style="text-align:center;">{{$t('common.nodata')}}</li>
                <li v-for="item in trendList" :key="item.pagelink">
                    <span class="page-access-linkname">{{item.pagelink}}</span>
                    <Progress :percent="item.numpro" style="width: 40%; float: right;">
                      <span>{{item.numpro}}%</span>
                    </Progress>
                </li>
            </ul>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios';
import bus from '../../libs/bus';
import numberSeparator from '../../filters/number-separator';
import numberToTime from '../../filters/number-to-time';
import util from '../../libs/util';
import editName from '../../components/app-pageaccess/edit-name';
import associativeSearch from '../../components/associative-search/index';

export default {
  props: {

  },
  components: {
    editName,
    associativeSearch,
  },
  filters: {
    numberSeparator,
    numberToTime,
  },
  data() {
    return {
      modal1: false,
      // 输入框内容
      key: '',
      pagelink: '',
      token: bus.token,
      tableColumns: [],
      tabDatas: [], // 绑定到table的data
      tableData: [], // 原始请求数据
      changeData: [], // 排序后改变的数据
      noData: this.$t('common.loading'),
      viewpagelist: [], // 被访问页面list
      page: [], // 页面list
      // 分页
      pages: 0,
      curPage: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],

      trend: false,
      trendData: [], // 页面转向原数据list
      trendList: [], // 筛选后页面转向list
      linkNoData: false, // 筛选后是否有数据

      // 平台
      platform: {
        1: {
          value: 1,
          name: 'android',
          icon: 'icon-android-r',
        },
        2: {
          value: 2,
          name: 'ios',
          icon: 'icon-iOS-r',
        },
        4: {
          value: 4,
          name: 'windows',
          icon: 'icon-windows-r',
        },
        16: {
          value: 16,
          name: 'html5',
          icon: 'icon-html-r',
        },
        32: {
          value: 32,
          name: 'weichat',
          icon: 'icon-miniprogram-r',
        },
        64: {
          value: 64,
          name: 'quickapp',
          icon: 'icon-kuaiyingyongSDK',
        },
      },
      // 用于取消请求
      source: axios.CancelToken.source(),
    };
  },
  computed: {
    vaildPlatform() {
      const platforms = JSON.parse(JSON.stringify(bus.platform));
      const showWatch = platforms.indexOf(2) > -1 && bus.productInfo.watchshow === 0;
      if (showWatch) {
        platforms.push(8);
      }
      return platforms;
    },
    dataJsonPlatform() {
      const platforms = bus.isAllPlatform ? [] : JSON.parse(JSON.stringify(bus.platform));
      const showWatch =
        !bus.isAllPlatform && platforms.indexOf(2) > -1 && bus.productInfo.watchshow === 0;
      if (showWatch) {
        platforms.push(8);
      }
      return platforms;
    },
  },
  mounted() {
    bus.$on('on-app-change', () => {
      this.init();
    });
    bus.$on('on-platform-change', () => {
      this.init();
    });
    bus.$on('on-conditions-change', () => {
      this.init();
    });
    bus.$on('on-date-change', () => {
      this.init();
    });
    bus.$on('on-change-lang', () => {
      this.tableColumns = this.getColumns();
    });

    this.init();
  },
  beforeDestroy() {
    // 清除请求
    this.source.cancel('clear request');
    bus.$off('on-app-change');
    bus.$off('on-platform-change');
    bus.$off('on-conditions-change');
    bus.$off('on-date-change');
  },
  methods: {
    ok() {
      this.$Message.info('Clicked ok');
    },
    cancel() {
      this.$Message.info('Clicked cancel');
    },
    init() {
      this.source.cancel('clear request');
      this.source = axios.CancelToken.source();
      this.noData = this.$t('common.loading');
      this.tableData = [];
      this.tabDatas = [];
      this.pages = 0;
      this.curPage = 1;
      if (bus.productInfo.productid !== '' && bus.productInfo.productid !== undefined) {
        this.getpageFrequency();
      }
      this.tableColumns = this.getColumns();
    },
    getColumns() { // 获取表头
      const self = this;
      const list = [{
        key: 'page',
        title: self.$t('pageaccess.table.page'),
        sortable: true,
        render(h, params) {
          return h('span', {
            attrs: {
              title: params.row.page,
            },
          }, params.row.page);
        },
      }, {
        key: 'pagename',
        title: self.$t('pageaccess.table.name'),
        width: 200,
        render(h, params) {
          return h(editName, {
            attrs: {
              id: params.row.id.toString(),
            },
            props: {
              page: params.row.page,
              pagename: params.row.pagename,
              platform: params.row.platform.toString(),
            },
            on: {
              'on-change-edit': self.setSiblingsEdit,
              'on-change-name-succ': self.updateTableData,
            },
          });
        },
        sortable: true,
      }, {
        key: 'userNum',
        title: self.$t('pageaccess.table.userNum'),
        width: 140,
        align: 'right',
        sortable: 'custom',
        render(h, params) {
          return [`${numberSeparator(params.row.userNum)}`];
        },
      }, {
        key: 'pageFrequency',
        title: self.$t('pageaccess.table.pageFrequency'),
        align: 'right',
        width: 170,
        sortable: 'custom',
        render(h, params) {
          return [`${numberSeparator(params.row.pageFrequency)} | ${params.row.pagePro}%`];
        },
      }, {
        key: 'alltimepro',
        title: self.$t('pageaccess.table.alltimepro'),
        align: 'right',
        sortable: 'custom',
        width: 120,
        render(h, params) {
          return [`${params.row.alltimepro}%`];
        },
      }, {
        key: 'stay',
        title: self.$t('pageaccess.table.stay'),
        align: 'right',
        sortable: 'custom',
        width: 110,
        render(h, params) {
          return [`${numberToTime(params.row.stay)}`];
        },
      }, {
        key: 'leave',
        title: self.$t('pageaccess.table.leave'),
        align: 'right',
        sortable: 'custom',
        width: 70,
        render(h, params) {
          return [`${params.row.leave}%`];
        },
      }, {
        key: 'trend',
        width: 70,
        title: self.$t('pageaccess.table.trend'),
        render(h, params) {
          return h('a', {
            on: {
              click: () => {
                self.checkDetail(params.row.page, params.row.leave, params.index);
              },
            },
          }, self.$t('pageaccess.checked'));
        },
      }];
      if (this.vaildPlatform.indexOf(32) > -1) {
        list.splice(2, 0, {
          key: 'pageVisitNum',
          title: self.$t('pageaccess.table.accessNum'),
          width: 100,
          align: 'right',
          sortable: 'custom',
          render(h, params) {
            return [`${numberSeparator(params.row.pageVisitNum)}`];
          },
        });
      }
      return list;
    },
    getData() { // 获取数据

    },
    // 自定义排序
    sortData(obj) { // table排序
      const key = this.key.toLowerCase();
      const data = this.tableData.filter(v => v.page.toLowerCase().indexOf(key) !== -1 ||
        v.pagename.toLowerCase().indexOf(key) !== -1);

      const list = this.pageSort(obj, data);
      this.changeData = list;
      this.getTableData(list, 1);
    },
    pageSort(obj, saveData) {
      const key = obj.key;
      const order = obj.order;
      const data = saveData;
      if (order === 'normal') {
        return data;
      }
      if (order === 'asc') {
        data.sort((a, b) => a[key] - b[key]);
      } else if (order === 'desc') {
        data.sort((a, b) => b[key] - a[key]);
      }
      return data;
    },
    getpageAndName() { // 获取页面以及页面显示名
      const self = this;
      util.ajax.post('/app/rest/page.json/getByProduct', {
        pageid: `pageInfo_${this.token}`,
        platformid: this.vaildPlatform.toString(),
        productid: bus.productInfo.productid,
        partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
        usergroup_list: bus.conditions.usergroup.length === 0 ? undefined
        : bus.conditions.usergroup,
        version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        const pagenameList = [];
        const viewpage = self.viewpagelist;
        for (let i = 0; i < viewpage.length; i += 1) {
          pagenameList.push(viewpage[i].pagename);
          for (let j = 0; j < res.length; j += 1) {
            if (viewpage[i].pagename === res[j].pagename) {
              const p = {};
              p.page = viewpage[i].pagename;
              p.pagename = res[j].pagedisplayname || viewpage[i].pagename;
              p.platform = res[j].platformid.toString().split(',');
              p.id = res[j].id;
              p.pageFrequency = '--';
              p.pagePro = '';
              p.userNum = '--';
              p.alltimepro = '--';
              p.stay = '--';
              p.leave = '--';
              p.trend = '';
              p.pageExit = '';
              p.pageVisitNum = 0;
              // self.tabDatas.push(p);
              self.tableData.push(p);
              break;
            }
          }
        }
        self.page = pagenameList;
        self.getuserNum();
        self.getpageStay();
        self.getpageExit();
        if (self.vaildPlatform.indexOf(32) > -1) {
          self.getPageVisitNum();
        }
      }).catch(() => {});
    },
    getpageFrequency() { // 获取页面受访次数 均值
      const self = this;
      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['pageview'],
        groupby: 'pagename',
        limit: 1000,
        pageid: `pageInfo_${this.token}`,
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: this.dataJsonPlatform.toString(),
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          usergroup_list: bus.conditions.usergroup.length === 0 ? undefined
          : bus.conditions.usergroup,
          version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        },
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        if (res.length > 0) {
          self.viewpagelist = res;
          self.getpageAndName();
        } else {
          self.noData = self.$t('common.nodata');
        }
      }).catch(() => {});
    },
    getPageVisitNum() {  //入口页次数 含有小程序平台时显示
      const self = this;
      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['portalPageAmt'],
        groupby: 'pageId',
        pageid: `pageInfo_${this.token}`,
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: this.dataJsonPlatform.toString(),
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
        },
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        const list = self.tableData;
        if (res.length) {
          for (let i = 0; i < res.length; i += 1) {
            for (let j = 0; j < list.length; j += 1) {
              if (res[i].pageId === list[j].page) {
                self.tableData[j].pageVisitNum = res[i].portalPageAmt ? res[i].portalPageAmt : '';
              }
            }
          }
        }
      }).catch(() => {});
    },
    getuserNum() { // 获取受访人数
      const self = this;
      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['launchuser'],
        groupby: 'pagename',
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: this.dataJsonPlatform.toString(),
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          pagename_list: self.page,
          partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          usergroup_list: bus.conditions.usergroup.length === 0 ? undefined
          : bus.conditions.usergroup,
          version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        },
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        const list = self.tableData;
        for (let i = 0; i < res.length; i += 1) {
          for (let j = 0; j < list.length; j += 1) {
            if (res[i].pagename === list[j].page) {
              self.tableData[j].userNum = res[i].launchuser;
            }
          }
        }
      }).catch(() => {});
    },
    getpageStay() { // 受访时长
      const self = this;
      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['pagestay'],
        groupby: 'pagename',
        pageid: `pageInfo_${this.token}`,
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: this.dataJsonPlatform.toString(),
          pagename_list: self.page,
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          usergroup_list: bus.conditions.usergroup.length === 0 ? undefined
          : bus.conditions.usergroup,
          version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        },
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        self.getAllPageviewStay(res);
        const pageview = self.viewpagelist;
        for (let i = 0; i < res.length; i += 1) { // 计算平均停留时长
          for (let j = 0; j < pageview.length; j += 1) {
            // let flag = false;
            if ((res[i].pagename === pageview[j].pagename)) {
              const result = Math.round(res[i].pagestay / pageview[j].pageview);
              // result = result === 'NaN' || result === 'Infinity' ? 0 : result;
              self.tableData[j].stay = result;
              // flag = true;
              // continue;
            }
          }
        }
      }).catch(() => {});
    },
    getpageExit() { // 页面离开
      const self = this;
      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['pageexit'],
        groupby: 'pagename',
        pageid: `pageInfo_${this.token}`,
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: this.dataJsonPlatform.toString(),
          pagename_list: self.page,
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          usergroup_list: bus.conditions.usergroup.length === 0 ? undefined
          : bus.conditions.usergroup,
          version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        },
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        const pageview = self.viewpagelist;
        for (let i = 0; i < res.length; i += 1) {
          for (let j = 0; j < pageview.length; j += 1) {
            // let flag = false;
            if ((res[i].pagename === pageview[j].pagename)) {
              if (self.tableData[j]) {
                self.tableData[j].pageExit = res[i].pageexit;
                let result = ((res[i].pageexit / pageview[j].pageview) * 100).toFixed(1);
                result = result < 0 ? '0.0' : result;
                self.tableData[j].leave = result === 'NaN' || result === 'Infinity' ?
                  '0.0' : `${result}`;
                // flag = true;
                // continue;
              }
            }
          }
        }
        self.getSearchData();
      }).catch(() => {});
    },
    getAllPageviewStay(pageStayList) { // pageview、pagestay总时长
      const self = this;
      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['pageview', 'pagestay'],
        groupby: 'productid',
        pageid: `pageInfo_${this.token}`,
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: this.dataJsonPlatform.toString(),
          //                      'pagename_list': self.page,
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        },
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        const pageview = this.viewpagelist;

        Object.keys(pageview).forEach((i) => { // 计算页面受访（次数 | 比率）
          self.tableData[i].pageFrequency = `${pageview[i].pageview}`;
          self.tableData[i].pagePro = `${((pageview[i].pageview / res[0].pageview) * 100).toFixed(1)}`;
          Object.keys(pageStayList).forEach((j) => {
            // let flag = false;
            if ((pageview[i].pagename === pageStayList[j].pagename)) {
              this.tableData[i].alltimepro =
              `${((pageStayList[j].pagestay / res[0].pagestay) * 100).toFixed(1)}`;
              // flag = true;
            }
          });
        });
      }).catch(() => {});
    },
    // search回调
    search(value) {
      this.key = value;
      this.getSearchData();
    },
    changePage(index) {
      this.curPage = index;
      this.getSearchData(index);
    },
    /**
     * 获取检索后数据
     * @param index, index为Object表示搜索框触发的此函数，index为Number表示改变页码触发的此函数，
     index为空，表示ajax数据获取后的操作
     **/
    getSearchData(index) {
      // 此为搜索框输入判断，输入关键词后changedData置空
      if (typeof (index) === 'object') this.changeData = [];
      const data = this.changeData.length > 0 ? this.changeData : this.tableData;
      const key = this.key.toLowerCase();
      if (key === '') {
        this.getTableData(data);
        return;
      }
      this.curPage = typeof (index) === 'object' || !index ? 1 : index;
      const result = [];
      Object.keys(data).forEach((i) => {
        if (data[i].page.toLowerCase().indexOf(key) !== -1 ||
          data[i].pagename.toLowerCase().indexOf(key) !== -1) {
          result.push(data[i]);
        }
      });
      this.pages = result.length;
      this.getTableData(result);
    },
    /**
     * 获取表格数据
     * @param filterRes {Array} 过滤后的所有数据
     * @param ind {Number} 排序操作--sortData后传递的值 为1,其余操作不传
     **/
    getTableData(filterRes, ind) {
      const cur = !ind ? this.curPage : ind;
      // 排序操作后当前页置为1
      this.curPage = !ind ? this.curPage : ind;
      const size = this.pageSize;
      this.pages = filterRes.length;

      const start = (cur - 1) * size;
      let offset = size;
      if (cur * size >= filterRes.length) {
        offset = filterRes.length - start;
      }
      const result = [];
      for (let i = start; offset > 0; i += 1) {
        result.push(filterRes[i]);
        offset -= 1;
      }
      this.tabDatas = result;
      if (result.length === 0) {
        this.noData = this.$t('common.nodata');
      }
    },
    downTable() { // 导出数据
      const downData = JSON.parse(JSON.stringify(this.tableData));

      Object.keys(downData).forEach((i) => {
        downData[i].pageFrequency += ` | ${downData[i].pagePro}%`;
        downData[i].alltimepro += '%';
        downData[i].stay = numberToTime(downData[i].stay);
        downData[i].leave += '%';
      });

      const tabClolumns = this.tableColumns.filter(col => col.key !== 'trend');
      const filename = bus.getDownloadName(this.$t('pageaccess.tab1'));
      this.$refs.table.exportCsv({
        filename,
        columns: tabClolumns,
        data: downData,
      });
    },
    checkDetail(page, leave, index) { // 查看走向
      this.trend = true;
      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['pagejump'],
        groupby: 'pagelink',
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: this.dataJsonPlatform.toString(),
          pagename_list: [page],
          start: bus.selectedDate[0],
          end: bus.selectedDate[1],
          version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        },
        pageid: `pageInfo_${this.token}`,
      }, {
        cancelToken: this.source.token,
      }).then((res) => {
        const data = JSON.parse(JSON.stringify(res));
        // 当前table显示的10条数据
        const tabData = this.tabDatas;
        let sum = tabData[index].pageExit;
        sum = sum < 0 ? 0 : sum;

        Object.keys(data).forEach((i) => {
          sum += data[i].pagejump;
        });

        Object.keys(data).forEach((j) => {
          Object.keys(this.tableData).forEach((k) => {
            // let flag = false;
            if ((data[j].pagelink === this.tableData[k].page)) {
              data[j].pagelink = this.tableData[k].pagename;
              let result = ((data[j].pagejump / sum) * 100).toFixed(1);
              result = result === 'NaN' || result === 'undefined' ? 0.0 : result;
              data[j].numpro = result * 1;
              data[j].pro = `${result}%`;
              // flag = true;
              // continue;
            }
          });
        });

        const p = {};
        p.pagelink = this.$t('pageaccess.table.leave');
        p.numpro = (leave * 1).toFixed(1) * 1;
        data.unshift(p);
        this.trendList = data;
        this.trendData = data;
      });
    },
    filterpagelink() { // 页面转向的搜索
      const data = this.trendData;
      const key = this.pagelink.toLowerCase();
      const result = [];
      Object.keys(data).forEach((i) => {
        if (data[i].pagelink.toLowerCase().indexOf(key) !== -1) {
          result.push(data[i]);
        }
      });
      this.linkNoData = result.length === 0;
      this.trendList = result;
    },

    // 关闭其他行的编辑名称
    setSiblingsEdit(id) {
      for (let i = 0; i < this.tabDatas.length; i += 1) {
        bus.$emit('on-close-edit', id);
      }
    },
    updateTableData(id, name) {
      this.tableData.forEach((v, i) => {
        if (v.id.toString() === id) {
          this.tableData[i].pagename = name;
        }
      });
    },
  },
};
</script>
